// Core
import React from "react"
import styled from "styled-components"

// General Components
import BaseContainer from "../../../../components/BaseContainer"

// Components
import ScheduleContainer from "./components/ScheduleContainer"
import FollowUsContainer from "./components/FollowUsContainer"

const Section = styled.section`
  padding-top: 10rem;
  padding-bottom: 10rem;

  img {
    width: 100%;
    height: 100%;
  }
`

export default function OnlineSchedule() {
  return (
    <Section>
      <BaseContainer>
        <ScheduleContainer />
        <FollowUsContainer />
      </BaseContainer>
    </Section>
  )
}
